export const getFakeVideoSearchResults = video => {
    if (video) {
        const matches = [
            {
                context: "and lorem Ipsum has been the industry's",
                startTime: "00:08:07.7640000",
                text: "lorem",
                type: "Transcript",
            },
            {
                context: "found lorem Ipsum passages, and",
                startTime: "00:10:50.7640000",
                text: "lorem",
                type: "Transcript",
            },
            {
                context: "lorem random ways!",
                startTime: "00:15:36.7640000",
                text: "lorem",
                type: "Transcript",
            },
            {
                context: "chunk of Lorem Ipsum used since the 1500s",
                startTime: "00:17:21.7640000",
                text: "lorem",
                type: "Transcript",
            },
            {
                context: "All the Lorem Ipsum generators on the Internet",
                startTime: "00:19:05.7640000",
                text: "lorem",
                type: "Transcript",
            },
        ];

        return {...video, searchMatches: matches};
    }
};
